<style lang="scss" scoped>
.settings {
	@include container();
	&__section {
		padding-bottom: 70px;
		border-bottom: 1px solid #eee;
		margin-bottom: 30px;
		&:last-child {
			margin-bottom: 0;
			border-bottom: 0;
		}
	}
	&__year {
		margin-left: 20px;
	}
	&__row {
		@include grid();
	}
	&__left {
		@include grid-col(4);
		padding-right: 40px;
	}
	&__right {
		@include grid-col(8);
	}
	&__pad-bottom {
		margin-bottom: 30px;
	}
	&__pad-right {
		padding: 20px;
	}
	&__border-bottom {
		border-bottom: 1px solid #eee;
	}
	& ::v-deep .el-cascader {
		width: 100% !important;
	}
	& .el-select {
		width: 100%;
	}
	.warning a {
		color: #eb4335 !important;
		font-weight: bold;
	}
	.preview {
		margin: 0;
	}

	.d-block {
		display:block;
		line-height:1;
		
	}
	.d-block ~ span, .warning-text {
			margin-bottom:50px;
			font-size:13px;
			color:red
		}

	&__supplementary-text {
		font-size: 12px;
		line-height: 1.3;
		padding-bottom: 10px;
	}

	.dashboardTiles {
		display:flex;
		flex-wrap: wrap;
		& div {
			& .dashboardTiles-item {
				min-width: 160px;
				margin: 10px 10px 0 0;
			}
		}
	}

}

</style>
<template lang="pug">
.settings
	.main-panel
		loading(v-if="!form && $apollo.loading")
		template(v-else-if="form")
			.main-panel__padding.settings__section(v-if="this.type=== 'school'")
				.settings__row
					.settings__left
						h2 School
					.settings__right 
						el-card.box-card.settings__pad-bottom
							.clearfix(slot="header")
								span {{ school.name }}
							el-form(label-position="top")
								template(v-if="school.Organisation")
									div.settings__pad-bottom
										div.settings__pad-bottom
											el-switch(v-model="form.org_sync_enabled")
											span.settings__pad-right Use organisation settings
								el-form-item(label="Admin email")
										el-input(size="medium", v-model="form.admin_email")
			.main-panel__padding.settings__section(v-if="features.account_crud && (!school.Organisation || !this.form.org_sync_enabled)")
				.settings__row
					.settings__left
						h2.mt-3 Scheduling
					.settings__right
						el-card.settings__pad-bottom
							.clearfix(slot="header")
								span Sync Schedule
							el-form(label-position="top")
								el-form-item(label="Up to four syncs can be run daily.")
									sync-schedules(v-model="form.sync_schedules", :persistedSchedules="form.sync_schedules", :autoSyncTime="form.auto_sync_time")
			.main-panel__padding.settings__section(v-if="features.account_crud && providerCode == 'gapps' && (!school.Organisation || !this.form.org_sync_enabled)")
				.settings__row
					.settings__left
						h2.mt-3 Google Classroom
						p Classes are created based on the <b>registration/roll groups</b> and <b>classes</b>.
						p Specific classes and registration/roll groups can be ignored from the "Match classes" page.
					.settings__right
						el-card.settings__pad-bottom(v-if="features.classroom")
							.clearfix(slot="header")
								span Google Classroom and class memberships
							el-form(label-position="top")
								el-form-item(label="Create new Google Classroom classes")
									el-radio(v-model="form.class_create_mode", label="auto", border="", size="medium") Automatically with Edusync Google
									el-radio(v-model="form.class_create_mode", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								el-form-item(label="Add students and staff to classes")
									el-radio(v-model="form.class_membership_mode", label="auto", border="", size="medium") Automatically with Edusync Google
									el-radio(v-model="form.class_membership_mode", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								el-form-item(label="Remove students from classes")
									el-radio(v-model="form.class_membership_deletion_mode_student", label="auto", border="", size="medium") Automatically with Edusync Google
									el-radio(v-model="form.class_membership_deletion_mode_student", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								el-form-item(label="Remove staff from classes")
									el-radio(v-model="form.class_membership_deletion_mode_employee", label="auto", border="", size="medium") Automatically with Edusync Google
									el-radio(v-model="form.class_membership_deletion_mode_employee", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								el-form-item(label="Archive classes")
									el-radio(v-model="form.class_auto_archive", label="auto", border="", size="medium") Automatically archive all at the end of academic year
									el-radio(v-model="form.class_auto_archive", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								el-form-item(v-if="form.class_auto_archive === 'auto'" label="Pause sync and archive classes from")
									el-date-picker(
										v-model="form.class_auto_archive_date", type="date", placeholder="Pick a day", :picker-options="pickerOption", format="dd/MM/yyyy")
								el-form-item(v-if="form.class_auto_archive === 'auto'" label="Create classes from (select a date after the academic year rollover has occurred in your SIS/MIS)")
									el-date-picker(v-model="form.class_rollover_date", type="date", placeholder="Pick a day", :picker-options="pickerOptionRollover", format="dd/MM/yyyy")
								el-form-item(v-if="false")
									div(slot="label")
										div Having archived your Google Classrooms at the end of the year, what would you like to do?
									el-select(name="format", v-model="form.class_reprovision_mode", placeholder="Select")
										el-option(
											label="I would like to reprovision existing Google Classrooms with their attached resources (as drafts)",
											value="reprovision_with_resources"
										)
										el-option(label="I would like to reprovision existing Google Classrooms without their attached resources", value="reprovision_without_resources")
										el-option(label="I would not like to reprovision my existing Google Classrooms", value="archive_only")
								el-form-item(
									label="When do you want your Google Classrooms to be reprovisioned?",
									v-if="false && form.class_auto_archive === 'auto' && form.class_reprovision_mode !== 'archive_only'"
								)
									el-date-picker(
										v-model="form.class_reprovision_date",
										type="date",
										placeholder="Pick a day",
										:picker-options="pickerOptionReprovision",
										format="dd/MM/yyyy"
									)
								el-form-item(v-if="this.type=== 'school'")
										custom-field-format(
											v-model="form.class_section",
											fieldLabel="Section",
											:fieldNames="fieldNames.class",
											:persistedFormat="form.class_section"
										)
								el-form-item(v-if="providerCode === 'gapps'")
									custom-field-format(
										v-model="form.course_name_format",
										:fieldLabel="`${classroomLabel} name`",
										:fieldNames="{...fieldNames.class, ...fieldNames.user.classTeacher, ...{ staff_code: fieldNames.user.employmentDetails['staff-code'] } }",
										:persistedFormat="form.course_name_format"
									)
								//- el-form-item(:label="`How should Edusync ${providerName} handle timetables?`")
								//-     el-radio(v-model='form.class_timetable_mode', label='auto', border='', size='medium') Maintain a timetable in a class's calendar
								//-     el-radio(v-model='form.class_timetable_mode', label='self', border='', size='medium') The school will manage a timetable directly in {{ providerName}}
			.main-panel__padding.settings__section(v-if="features.account_crud && (!school.Organisation || !this.form.org_sync_enabled)")
				.settings__row
					.settings__left
						h2.mt-3 {{ providerName }} Groups
						p Standard groups are created based on <b>registration/roll groups</b>, <b>years</b> and <b>houses</b>.
						p(v-if="providerCode === 'msft'") Classes (Teaching sets) and Registration groups can be managed from the “Match classes” page.
						p(v-if="providerCode === 'msft'") Only groups of this type will be actioned by the <b>Archive classes</b> setting and any associated Entra ID groups will be deleted during this archiving process.
						p(v-if="providerCode === 'msft'") Year and House Groups can be managed from the “Match groups” page.
						p(v-if="providerCode !== 'msft'") Specific groups can be ignored from the "Match Groups" page.
						p(v-if="providerCode !== 'msft'") Non-standard groups are available for only some MISes.
					.settings__right
						el-card.settings__pad-bottom(v-if="features.group")
							.clearfix(slot="header")
								span Standard groups
							el-form(label-position="top")
								el-form-item(:label="providerCode !== 'msft' ? 'Create new groups' : 'Create new groups and teams'")
									el-radio(v-model="form.group_create_mode", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
									el-radio(v-model="form.group_create_mode", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								el-form-item(label="Add staff and students to groups")
									el-radio(v-model="form.group_membership_mode", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
									el-radio(v-model="form.group_membership_mode", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								el-form-item(label="Remove students from groups")
									el-radio(v-model="form.group_membership_deletion_mode_student", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
									el-radio(v-model="form.group_membership_deletion_mode_student", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								el-form-item(label="Remove staff from groups")
									el-radio(v-model="form.group_membership_deletion_mode_employee", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
									el-radio(v-model="form.group_membership_deletion_mode_employee", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								div(v-if="providerCode === 'msft'")
									el-form-item(label="Archive classes")
										el-radio(v-model="form.class_auto_archive", label="auto", border="", size="medium") Archive all at the end of academic year
										el-radio(v-model="form.class_auto_archive", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
									el-form-item(v-if="form.class_auto_archive === 'auto'" label="Pause sync and archive classes from")
										el-date-picker(
											v-model="form.class_auto_archive_date",
											type="date",
											placeholder="Pick a day",
											:picker-options="pickerOption",
											format="dd/MM/yyyy"
										)
									el-form-item(v-if="form.class_auto_archive === 'auto'" label="until")
										el-date-picker(v-model="form.class_rollover_date", type="date", placeholder="Pick a day", :picker-options="pickerOptionRollover", format="dd/MM/yyyy")
									//- el-form-item()
									//- 	el-switch(v-model='form.include_class_code')
									//- 	span.settings__pad-right Include class code when generating teams
									el-form-item()
										el-switch(v-model='form.multiple_class_mapping_enabled')
										span.settings__pad-right Enable mapping teams to multiple classes
									div(v-if="features.ou && this.type === 'school'")
										el-form-item(:label="`${orgUnitLabel.acronym} (${capitalize(orgUnitLabel.name)}) for group creation and management`")
											organisation-selector(v-model="form.group_org_unit_id")
										student-ou-structure(v-if="features.ou_structure", v-model="form.group_org_unit_structure")
								el-form-item(v-if="providerCode === 'msft'")
									custom-field-format(
										v-model="form.course_name_format",
										:fieldLabel="`${classroomLabel} name`",
										:fieldNames="{...fieldNames.class, ...fieldNames.user.classTeacher, ...{ staff_code: fieldNames.user.employmentDetails['staff-code'] } }",
										:persistedFormat="form.course_name_format"
									)
									
						el-card.settings__pad-bottom(v-if="features.group && newGroups")
							el-form(label-position="top")
								el-form-item()
									el-switch(v-model='group_type', @change="onChangeGroupTypes()")
									span.settings__pad-right Non-standard groups
								el-form-item(v-if="(group_type) && loading === false", label="")
									el-checkbox-group(v-model="create_groups")
										el-checkbox(v-for="group in newGroups", :label="group.name", :key="group.id")
											span {{ group.name }}
			.main-panel__padding.settings__section
				.settings__row
					.settings__left
						h2 Domains 
							span(v-if="providerCode !== 'apl'") and {{ orgUnitLabel.acronym }}s
							el-alert(v-if="providerCode === 'msft'" type="warning" show-icon description="Please ensure that the AU you select is configured for “assigned” rather than “dynamic user” membership to avoid issues with user creation")
					.settings__right
						el-card.box-card.settings__pad-bottom
							.clearfix(slot="header")
								span Students
							el-form(label-position="top")
								el-form-item(label="Student domain")
									el-select(v-if="providerCode == 'gapps'", name="format", v-model="form.domain", placeholder="Select")
										el-option(v-for="item in domains", :key="item.id", :label="item.id", :value="item.id")
									el-input(v-else, size="medium", v-model="form.domain")
								div(v-if="features.ou")
									el-form-item(:label="`${orgUnitLabel.acronym} (${capitalize(orgUnitLabel.name)}) for student creation and management`")
										organisation-selector(v-model="form.student_org_unit_id")
									student-ou-structure(v-if="features.ou_structure", v-model="form.student_org_unit_structure")
						el-card.box-card.settings__pad-bottom
							.clearfix(slot="header")
								span Staff
							el-form(label-position="top")
								el-form-item(label="Staff domain")
									el-select(v-if="providerCode == 'gapps'", name="format", v-model="form.domain_employee", placeholder="Select")
										el-option(v-for="item in domains", :key="item.id", :label="item.id", :value="item.id")
									el-input(v-else, size="medium", v-model="form.domain_employee")
								div(v-if="features.ou")
									el-form-item(:label="`${orgUnitLabel.acronym} (${capitalize(orgUnitLabel.name)}) for staff  creation and management`")
										organisation-selector(v-model="form.employee_org_unit_id")
						el-card.box-card(v-if="form.student_pre_admission_active")
							.clearfix(slot="header")
								span Pre-admission
							el-form(label-position="top")
								el-form-item(label="Pre-admission domain")
									el-select(v-if="providerCode == 'gapps'", name="format", v-model="form.domain_student_pre_admission", placeholder="Select")
										el-option(v-for="item in domains", :key="item.id", :label="item.id", :value="item.id")
									el-input(v-else, size="medium", v-model="form.domain_student_pre_admission")
								div(v-if="features.ou")
									el-form-item(:label="`${orgUnitLabel.acronym} (${capitalize(orgUnitLabel.name)}) for pre-admission creation and management`")
										organisation-selector(v-model="form.student_pre_admission_org_unit_id")
			.main-panel__padding.settings__section
				.settings__row
					.settings__left
						h2.mt-3 Rules
						p Control which students and staff are synced using filter rules.
					.settings__right
						student-rules.settings__pad-bottom(v-model="student_rule_object")
						employee-rules.settings__pad-bottom(v-model="employee_rule_object")
						preadmission-rules.settings__pad-bottom(v-model="form.student_pre_admission_active")
			.main-panel__padding.settings__section(v-if="!school.Organisation || !this.form.org_sync_enabled")
				.settings__row
					.settings__left
						h2.mt-3 Account management
					.settings__right
						el-card.settings__pad-bottom(v-if="features.account_crud")
							.clearfix(slot="header")
								span Student Accounts
							el-form(label-position="top")
									el-form-item(label="Create user accounts")
										el-radio(v-model="form.creation_mode", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
										el-radio(v-model="form.creation_mode", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}	
									email-format(
										v-model="form.email_format_student",
										userType="student",
										fieldLabel="Student email format (naming convention)",
										:domain="form.domain",
										:excludedFields="excludedFields[providerCode]",
										:settingsType="type"
									)
									el-form-item(v-if="['msft', 'gapps'].includes(providerCode)" label="Available Dictionaries to use to generate password (drag me)")
										el-alert(v-if="providerCode === 'msft'" type="warning" center description="Microsoft enforces a password complexity to include mixed case letters and numbers in a password, therefore passwords generated will start with uppercase and end in numbers")
										template(v-for="(item,i) in passwordDictionaries.filter((dictionary) => dictionary.type === 'common')")
											el-button(v-if="item.providers.includes(providerCode)" size="mini" :id="item.label" draggable @dragstart.native="drag") {{item.label}}
									el-form-item(v-if="['msft', 'gapps'].includes(providerCode)" label="Available User fields to use to generate password (drag me)")
										el-alert(type="warning" center description="Before generating passwords using user fields, it's safer to include a predefined dictionary for added security.")
										template(v-for="(item,i) in passwordDictionaries.filter((dictionary) => dictionary.type === 'mis_fields')")
											el-button(v-if="item.providers.includes(providerCode)" size="mini" :id="item.label" draggable @dragstart.native="drag") {{item.label}}		
									el-form-item(label='Student password to generate from the above dictionaries')
										el-alert(v-if="form.use_same_password" type="warning" center description="Because setting a common password for all students is turned on you can't use this feature, turn off set common password for all students if you wish to use this feature")
										el-select(v-model="student_password_generation" clearable @drop.native="!form.use_same_password ? dropDictionary($event,'student') : []" @dragover.native.prevent @dragenter.native.prevent multiple :multiple-limit="isCustomFormat ? 1 : 0" filterable default-first-option placeholder="Type / Drag elements here from the above list")
											el-option(v-for="(item,i) in passwordDictionaryOptions.student" :key="i" :label="item.label" :value="item.value" )
										p(class='preview') Preview: 
											b {{studentPasswordPreview}}
									el-form-item.settings__pad-bottom
										el-switch(v-model='form.use_same_password')
										span.settings__pad-right Set a common password for all students
											|  (<i class="el-icon-warning" style="color:#e6a23c"></i> not recommended)
										el-input(v-model="form.user_password", :type="isPasswordVisible ? 'text' : 'password'", :disabled="!useSamePassword")
											el-button(slot="append", :icon="isPasswordVisible ? 'el-icon-remove-outline' : 'el-icon-view'", @click="isPasswordVisible=!isPasswordVisible")
									div.settings__pad-bottom
										el-switch(v-model='form.student_change_password_at_next_login')
										span.settings__pad-right Force password change at next login for students
									template(v-if="providerCode === 'msft' && this.type === 'school'")
										div.settings__pad-bottom
											el-switch(v-model='form.parental_controls_enabled')
											span.settings__pad-right Parental controls
										template(v-if="form.parental_controls_enabled")
											el-form-item(label="Set age group")
												el-radio(v-model="form.age_group_student.type", label="age", border="", size="medium") With age
												el-radio(v-model="form.age_group_student.type", label="year group", border="", size="medium") With year group
											el-form-item(:label="`Minor ${form.age_group_student.type} range`")
													el-input-number(:min="0", :max="20", size="medium", v-model="form.age_group_student.minor.minimum")
													|
													| to 
													el-input-number(:min="0", :max="20", size="medium", v-model="form.age_group_student.minor.maximum", @change="changeAgeGroup")
											el-form-item(:label="`Not adult ${form.age_group_student.type} range`")
													el-input-number(:min="form.age_group_student.minor.maximum + 1", :max="20", size="medium", v-model="form.age_group_student.not_adult.minimum")
													|
													| to 
													el-input-number(:min="0", :max="20", size="medium", v-model="form.age_group_student.not_adult.maximum", @change="changeAgeGroup")
											el-form-item(:label="`Adult minimum ${form.age_group_student.type}`")
													el-input-number(:min="form.age_group_student.not_adult.maximum + 1", :max="25", size="medium", v-model="form.age_group_student.adult.minimum")
											el-form-item(label="Consent provided for minor")
												el-select(name="format", v-model="form.consent_provided_for_minor", placeholder="Select")
													el-option(v-for="item in consentProvidedForMinorOptions", :key="item.value", :label="item.label", :value="item.value")
									
						el-card.settings__pad-bottom(v-if="features.account_crud")
							.clearfix(slot="header")
								span Staff Accounts
							el-form(label-position="top")
								el-form-item(label="Create staff user accounts")
									el-radio(v-model="form.creation_mode_employee", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
									el-radio(v-model="form.creation_mode_employee", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								email-format(
									v-model="form.email_format_employee",
									userType="employee",
									fieldLabel="Employee email format (naming convention)",
									:domain="form.domain_employee",
									:excludedFields="excludedFields[providerCode]",
									:settingsType="type"
								)
								el-form-item(v-if="providerCode === 'gapps' || providerCode === 'msft'" label="Staff account format")
									el-radio(v-model="form.hide_employee_forename", :label="0", border="", size="medium") {first name} + {last name}
									el-radio(v-model="form.hide_employee_forename", :label="1", border="", size="medium") {title} + {last name}
								el-form-item(v-if="['msft', 'gapps'].includes(providerCode)" label="Available Dictionaries to use to generate password (drag me)")
									el-alert(v-if="providerCode === 'msft'" type="warning" center description="Microsoft enforces a password complexity to include mixed case letters and numbers in a password, therefore passwords generated will start with uppercase and end in numbers")
									template(v-for="(item,i) in passwordDictionaries.filter((dictionary) => dictionary.type === 'common')")
										el-button(v-if="item.providers.includes(providerCode)" size="mini" :id="item.label" draggable @dragstart.native="drag") {{item.label}}
								el-form-item(v-if="['msft', 'gapps'].includes(providerCode)" label="Available User fields to use to generate password (drag me)")
									el-alert(type="warning" center description="Before generating passwords using user fields, it's safer to include a predefined dictionary for added security.")
									template(v-for="(item,i) in passwordDictionaries.filter((dictionary) => dictionary.type === 'mis_fields')")
										el-button(v-if="item.providers.includes(providerCode)" size="mini" :id="item.label" draggable @dragstart.native="drag") {{item.label}}
								el-form-item(label='Staff password to generate from the above dictionaries')
									el-alert(v-if="form.use_same_staff_password" type="warning" center description="Because setting a common password for all staff is turned on you can't use this feature, turn off set common password for all staff if you wish to use this feature")
									el-select(v-model="employee_password_generation" clearable @drop.native="!form.use_same_staff_password ? dropDictionary($event,'employee') : []" @dragover.native.prevent @dragenter.native.prevent multiple :multiple-limit="isCustomFormat ? 1 : 0" filterable default-first-option placeholder="Type / Drag elements here from the above list")
										el-option(v-for="(item,i) in passwordDictionaryOptions.employee" :key="i" :label="item.label" :value="item.value" )
									p(class='preview') Preview: 
										b {{employeePasswordPreview}}
								el-form-item
									el-switch(v-model='form.use_same_staff_password')
									span.settings__pad-right Set a common password for all staff
										|  (<i class="el-icon-warning" style="color:#e6a23c"></i> not recommended)
									el-input(v-model="form.employee_password", :type="isStaffPasswordVisible ? 'text' : 'password'", :disabled="!useSameStaffPassword")
										el-button(slot="append", :icon="isStaffPasswordVisible ? 'el-icon-remove-outline' : 'el-icon-view'", @click="isStaffPasswordVisible=!isStaffPasswordVisible")
									div
										el-switch(v-model='form.employee_change_password_at_next_login')
										span.settings__pad-right Force password change at next login for staff
								el-form-item(label="Student org department", v-if="providerCode === 'gapps'")
									el-input(size="medium", v-model="form.student_org_department")
								el-form-item(label="Employee org department", v-if="providerCode === 'gapps'")
									el-input(size="medium", v-model="form.employee_org_department")
								//- div
								//- 	el-switch(v-model='form.enforce_mfa') // Add back in if possible after investigation work done in ESYNC-614
								//- 	span.settings__pad-right Enforce MFA for created users
								//- 		|  (<i class="el-icon-warning" style="color:#e6a23c"></i> If you enable MFA, then created users will be required to configure MFA when they next login, including providing contact/token details.)
								el-form-item(v-if="providerCode==='gapps'")
									el-switch(v-model='form.future_employee_enabled')
									span.settings__pad-right Enable future staff account creation
								el-form-item(label="Create future staff account", v-if="providerCode==='gapps' && form.future_employee_enabled")
									el-input-number(:min="1", :max="365", size="medium", v-model="form.future_employee_creation_lead_time", e2e="future_employee_creation_lead_time")
									|
									| {{ form.future_employee_creation_lead_time == 1 ? 'day' : 'days' }} before staff start date
						el-card.settings__pad-bottom(v-if="features.account_crud && form.student_pre_admission_active")
							.clearfix(slot="header")
								span Pre-admission Accounts
							el-form(label-position="top")
									email-format(
										v-model="form.email_format_student_pre_admission",
										userType="student_pre_admission",
										fieldLabel="Pre-admission email format (naming convention)",
										:domain="form.domain_student_pre_admission",
										:excludedFields="excludedFields[providerCode]",
										:settingsType="type"
									)
									
						el-card.settings__pad-bottom(v-if="features.account_crud")
							.clearfix(slot="header")
								span Account suspension and deletion
							el-form(label-position="top")
								p(v-if="form.student_org_unit_id && form.employee_org_unit_id && form.student_org_unit_id.toString() === form.employee_org_unit_id.toString() && features.account_crud") Note: To control student and employee deletions separately, they will need to be configured to use separate org units.
								el-form-item(label="Suspend and delete student accounts")
									el-radio(v-model="form.deletion_mode_student", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
									el-radio(v-model="form.deletion_mode_student", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								template(v-if="form.deletion_mode_student == 'auto'")
									el-form-item(label="Suspend student accounts")
										el-input-number(:min="0", :max="365", size="medium", v-model="form.suspend_delay_student", e2e="suspend_days")
										|
										| {{ form.suspend_delay_student == 1 ? 'day' : 'days' }} after removal from the MIS
									el-form-item(label="Delete suspended student accounts after")
										el-input-number(:min="0", size="medium", v-model="deletion_years.student")
										|
										| {{ deletion_years.student == 1 ? 'year' : 'years' }} and 
										el-input-number.settings__year(:min="0", :max="365", size="medium", v-model="deletion_days.student")
										|
										| {{ deletion_days.student == 1 ? 'day' : 'days' }}
								el-form-item(label="Suspend and delete staff accounts")
									el-radio(v-model="form.deletion_mode_employee", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
									el-radio(v-model="form.deletion_mode_employee", label="self", border="", size="medium") Manually within {{ providerName }} {{ adminConsoleLabel }}
								template(v-if="form.deletion_mode_employee == 'auto'")
									el-form-item(label="Suspend staff accounts")
										el-input-number(:min="0", :max="365", size="medium", v-model="form.suspend_delay_employee", e2e="suspend_days")
										|
										| {{ form.suspend_delay_employee == 1 ? 'day' : 'days' }} after removal from the MIS
									el-form-item(label="Delete suspended staff accounts after")
										el-input-number(:min="0", size="medium", v-model="deletion_years.employee")
										|
										| {{ deletion_years.employee == 1 ? 'year' : 'years' }} and 
										el-input-number.settings__year(:min="0", :max="365", size="medium", v-model="deletion_days.employee")
										|
										| {{ deletion_days.employee == 1 ? 'day' : 'days' }}
								el-form-item(label="Define an OU for suspended users be moved to" v-if="providerCode === 'gapps'")
									el-alert(type="warning" description="If you don't define an OU for suspended users they will remain in their current OU.")
									organisation-selector(v-model="form.leavers_OU")
						el-card.settings__pad-bottom(v-if="features.account_crud")
							.clearfix(slot="header")
								span Account matching
							el-form(label-position="top")
								el-form-item(label="Match staff")
									el-radio(v-model="form.matching_emails_only_employee", :label="true", border="", size="medium") Using emails only
									el-radio(v-model="form.matching_emails_only_employee", :label="false", border="", size="medium") Using emails and names
							el-form(label-position="top")
								el-form-item(label="Match students")
									el-radio(v-model="form.matching_emails_only_student", :label="true", border="", size="medium") Using emails only
									el-radio(v-model="form.matching_emails_only_student", :label="false", border="", size="medium") Using emails and names
							div.settings__pad-bottom
								div.settings__pad-bottom
									el-switch(v-model="form.predictions_auto_enabled")
									span.settings__pad-right Automated predictions matching
							
						el-card.settings__pad-bottom(v-if="features.account_crud && providerCode === 'msft' && this.type === 'school'")
							.clearfix(slot="header")
								span Additional attributes
							el-form(label-position="top")
								custom-field-format(
											v-model="form.department_student",
											fieldLabel="Student department ",
											:fieldNames="{...fieldNames.groups, ...fieldNames.school, ...fieldNames.user.educationDetails, ...{'mis-tertiary-id': fieldNames.user.identifiers.student[`mis-tertiary-id`] }}",
											settingKey="department_student"
								)
								custom-field-format(
									v-model="form.office_location_student",
									fieldLabel="Student office location",
									:fieldNames="{...fieldNames.groups, ...fieldNames.school, ...governmentIDField, ...fieldNames.user.educationDetails, ...{'mis-tertiary-id': fieldNames.user.identifiers.student[`mis-tertiary-id`] }}",
									settingKey="office_location_student"
								)
								el-form-item(label='Student job title')
									el-input(:disabled="true" value="Student")
								custom-field-format(
									v-model="form.postal_code_student",
									fieldLabel="Student ZIP/postal code",
									:fieldNames="{...fieldNames.user.identifiers.student, ...fieldNames.user.educationDetails}",
									:persistedFormat="form.postal_code_student"
								)
								custom-field-format(
											v-model="form.department_employee",
											fieldLabel="Staff department ",
											:fieldNames="{...fieldNames.groups, ...fieldNames.school}",
											settingKey="department_employee"
								)
								custom-field-format(
									v-model="form.office_location_employee",
									fieldLabel="Staff office location",
									:fieldNames="{...fieldNames.groups, ...fieldNames.school, ...governmentIDField}",
									settingKey="office_location_employee"
								)
								custom-field-format(
									v-model="form.job_title",
									fieldLabel="Staff job title",
									:fieldNames="{...fieldNames.groups, ...fieldNames.title}",
									settingKey="job_title"
								)
								custom-field-format(
									v-model="form.employee_type",
									fieldLabel="Employee type",
									:fieldNames="{...fieldNames.groups, ...fieldNames.title}",
									settingKey="employee_type"
								)
						el-card.settings__pad-bottom(v-if="providerCode == 'apl'")
							.clearfix(slot="header")
								span Account creation
							el-form(label-position="top")
								template(v-if="providerCode === 'apl'")
									div.settings__pad-bottom
										el-form-item(label="Student Identifier")
											el-radio(v-model="form.student_id_field", label="edusync_id", border="") Edusync ID
											el-radio(v-model="form.student_id_field", label="mis_id", border="") {{ misLabel }} ID
											<br>
											span.warning-text(v-if="form.student_id_field !== 'edusync_id'") Only use this if the ID is unique across all your users regardless of type to avoid missing users due to conflict
										el-form-item(label="Employee Identifier")
											el-radio(v-model="form.employee_id_field", label="edusync_id", border="") Edusync ID
											el-radio(v-model="form.employee_id_field", label="mis_id", border="") {{ misLabel }} ID
											el-radio(v-model="form.employee_id_field", label="teacher_id", border="") Teacher ID
											<br>
											span.warning-text(v-if="form.employee_id_field !== 'edusync_id'") Only use this if the ID is unique across all your users regardless of type to avoid missing users due to conflict
						el-card.settings__pad-bottom(v-if="providerCode == 'apl'")
							.clearfix(slot="header")
								span Account deactivation
							el-form(label-position="top")
								el-form-item(v-if="providerCode === 'apl'")
									el-radio(v-model="form.deletion_mode_student", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
									el-radio(v-model="form.deletion_mode_student", label="self", border="", size="medium") Manually within {{ providerName }} School Manager
								template(v-if="form.deletion_mode_student == 'auto'")
									el-form-item(label="Deactivate student accounts after")
										el-input-number(:min="0", :max="365", size="medium", v-model="form.suspend_delay_student", e2e="suspend_days")
										|
										| {{ form.suspend_delay_student == 1 ? 'day' : 'days' }}
										<br>
										span.warning-text Staff will be automatically deactivated according to their leaving date in your MIS
			.main-panel__padding.settings__section(v-else)
				.settings__row
					.settings__left
						h2.mt-3 Account management
					.settings__right
						el-card.settings__pad-bottom(v-if="features.account_crud")
							.clearfix(slot="header")
								span Account matching
							div.settings__pad-bottom
								div.settings__pad-bottom
									el-switch(v-model="form.predictions_auto_enabled")
									span.settings__pad-right Automated predictions matching

			.main-panel__padding.settings__section(v-if="this.type=== 'school'")
				.settings__row
					.settings__left
						h2.mt-3 Advanced mapping
					.settings__right
						el-card.settings__pad-bottom
							.clearfix(slot="header")
								span Student data fields
							el-form(label-position="top")
								custom-field-format(
									v-model="form.first_name_student",
									fieldLabel="First name ",
									:fieldNames="{ ...fieldNames.user.name, ...fieldNames.user.educationDetails, ...fieldNames.user.identifiers.student, ...fieldNames.user.regionalData }",
									:persistedFormat="form.first_name_student"
								)
								//- custom-field-format(
								//- 	v-model="form.middle_name_student",
								//- 	fieldLabel="Middle name ",
								//- 	:fieldNames="{ ...fieldNames.user.name, ...fieldNames.user.educationDetails, ...fieldNames.user.identifiers.student, ...fieldNames.user.regionalData }",
								//- 	:persistedFormat="form.middle_name_student"
								//- )
								custom-field-format(
									v-model="form.last_name_student",
									fieldLabel="Last name ",
									:fieldNames="{ ...fieldNames.user.name, ...fieldNames.user.educationDetails, ...fieldNames.user.identifiers.student, ...fieldNames.user.regionalData }",
									:persistedFormat="form.last_name_student"
								)
						el-card.settings__pad-bottom
							.clearfix(slot="header")
								span Staff data fields
							el-form(label-position="top")
								custom-field-format(
									v-model="form.first_name_employee",
									fieldLabel="First name ",
									:fieldNames="{ ...fieldNames.user.name, ...fieldNames.user.employmentDetails, ...fieldNames.user.identifiers.employee }",
									:persistedFormat="form.first_name_employee"
								)
								//- custom-field-format(
								//- 	v-model="form.middle_name_employee",
								//- 	fieldLabel="Middle name ",
								//- 	:fieldNames="{ ...fieldNames.user.name, ...fieldNames.user.employmentDetails, ...fieldNames.user.identifiers.employee }",
								//- 	:persistedFormat="form.middle_name_employee"
								//- )
								custom-field-format(
									v-model="form.last_name_employee",
									fieldLabel="Last name ",
									:fieldNames="{ ...fieldNames.user.name, ...fieldNames.user.employmentDetails, ...fieldNames.user.identifiers.employee }",
									:persistedFormat="form.last_name_employee"
								)
		slot(name="footer")
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import moment from "moment";
import StudentRules from "./StudentRules";
import StudentOuStructure from "./StudentOuStructure";
import OrganisationSelector from "./OrganisationSelector";
import EmployeeRules from "./EmployeeRules";
import PreadmissionRules from "./PreadmissionRules";
import emailValidator from "email-validator";
import EmailFormat from "./EmailFormat.vue"
import CustomFieldFormat from './CustomFieldFormat';
import SyncSchedules from './SyncSchedules';

export default {
	components: {
		OrganisationSelector,
		StudentRules,
		EmployeeRules,
		StudentOuStructure,
		EmailFormat,
		CustomFieldFormat,
		SyncSchedules,
		PreadmissionRules
	},

	props: {
		type: String,
	},

	computed: {
		domain () {
			return this.form.domain_employee || this.form.domain
		},
		misLabel() {
			return this.providerCode === "apl" ? "MIS/SIS" : "MIS";
		},
		classroomLabel() {
			return this.providerCode === "msft" ? "Team/Group" : "Classroom";
		},
		emailFormatChange() {
			return {
				student: this.providerCode === "gapps" && !_.isEmpty(this.originalSettingsValues) && !_.isEmpty(this.form) && !this.form.email_format_student.usingBrokenJS && (this.originalSettingsValues.domain !== this.form.domain || this.originalSettingsValues.email_format_student !== this.form.email_format_student.format),
				employee: this.providerCode === "gapps" &&  !_.isEmpty(this.originalSettingsValues) && !_.isEmpty(this.form) && !this.form.email_format_employee.usingBrokenJS && (this.originalSettingsValues.domain_employee !== this.form.domain_employee || this.originalSettingsValues.email_format_employee !== this.form.email_format_employee.format),
			}
		},
		orgUnitLabel() {
			return this.providerCode === "gapps" ? {
				acronym: "OU",
				name: "organisational unit"
			} : {
				acronym: "AU",
				name: "administrative unit"
			};
		},
		adminConsoleLabel() {
			return this.providerCode === "gapps" ? "admin console" : "Entra ID";
		},
		useSamePassword() {
			return this.form.use_same_password || !_.isEmpty(this.form.user_password);
		},
		useSameStaffPassword() {
			return this.form.use_same_staff_password || !_.isEmpty(this.form.employee_password);
		},
		governmentIDField() {
			return _.pick(this.fieldNames.user.regionalData, ["au-gov-id"]);
		}
	},

	apollo: {
		domains: {
			query: gql`
				{
					Domains(verified: true) {
						id
						primary
						verified
					}
				}
			`,
			update: (r) => r.Domains,
		},
		previewUser: {
			query: gql`
				{
					User {
						first_name
						last_name
					}
				}
			`,
			update: (r) => r.User,
		},
		form: {
			query: gql`
                query Settings($type: SettingsTypeEnum!) {
                    Settings(type: $type) {
						id
						creation_mode
						creation_mode_employee
						deletion_mode_student
						deletion_mode_employee
						leavers_OU
						group_create_mode
						group_membership_mode
						class_create_mode
						class_membership_mode
						class_timetable_mode
						group_membership_deletion_mode_student
						group_membership_deletion_mode_employee
						class_membership_deletion_mode_student
						class_membership_deletion_mode_employee
						creation_groups
						deletion_delay_student
						deletion_delay_employee
						suspend_delay_student
						suspend_delay_employee
						student_active
						email_format_employee
						student_password_generation
						employee_password_generation
						hide_employee_forename
						custom_email_letters
						email_format_student
						email_format_student_split_by_firstN
                        email_format_employee_split_by_firstN
						email_format_student_pre_admission_split_by_firstN
                        email_format_student_split_by_lastN
                        email_format_employee_split_by_lastN
						email_format_student_pre_admission_split_by_lastN
						employee_active
						employee_org_unit_id
						student_org_unit_id
						student_pre_admission_org_unit_id
						group_org_unit_id
						domain
						domain_employee
						email_formats
						student_provision_rules {
							group
							operator
							value
						}
						student_org_unit_structure
						class_auto_archive
						class_auto_archive_date
						class_reprovision_mode
						class_reprovision_date
						group_create_misc {
							id
							name
							type
						}
						dashboard_tiles
						user_password
						employee_password
						class_rollover_date
						student_use_mis_email
						employee_use_mis_email
						use_person_mis_id
						student_change_password_at_next_login
						employee_change_password_at_next_login
						enforce_mfa
						org_sync_enabled
						department_student
						department_employee
						office_location_student
						office_location_employee
						job_title
						postal_code_student
						matching_emails_only_employee
						matching_emails_only_student
						include_class_code
						student_org_department
						employee_org_department
                        auto_sync_time
                        sync_schedules {
                            enabled
                            time
                        }
						admin_email
						predictions_auto_enabled
						first_name_student
						middle_name_student
						first_name_employee
						middle_name_employee
						last_name_employee
						last_name_student
						age_group_student {
							adult {
								minimum
							}
							minor {
								minimum
								maximum
							}
							not_adult {
								minimum
								maximum
							}
							type
						}
						course_name_format
						multiple_class_mapping_enabled
						consent_provided_for_minor
						class_section
						parental_controls_enabled
						student_pre_admission_active
						domain_student_pre_admission
						email_format_student_pre_admission
						future_employee_enabled
						future_employee_creation_lead_time
					}
				}
			`,
			variables() {
                return {
                    type: this.type
                }
            },
			fetchPolicy: "cache-and-network",
			update(r) {
				this.loadingForm = true;
				let settings = _.cloneDeep(r.Settings);
				if (_.isEmpty(this.originalSettingsValues)) {
					this.originalSettingsValues = _.cloneDeep(r.Settings);
				}
				this.student_rule_object.rules = _.cloneDeep(settings.student_provision_rules);
				this.student_rule_object.active = _.cloneDeep(settings.student_active);
				delete settings.student_provision_rules;
				delete settings.student_provision_rule_match;
				delete settings.student_active;
				this.student_password_generation = settings.student_password_generation;
				this.employee_password_generation = settings.employee_password_generation;
				this.employee_rule_object.active = _.cloneDeep(settings.employee_active);
				delete settings.employee_active;
				settings.hide_employee_forename = settings.hide_employee_forename | 0;
				this.create_groups = settings.group_create_misc ? settings.group_create_misc.map(item => item) : [];
				settings.student_change_password_at_next_login = settings.student_change_password_at_next_login == 1;
				settings.employee_change_password_at_next_login = settings.employee_change_password_at_next_login == 1;
				settings.enforce_mfa = settings.enforce_mfa == 1;
				this.group_type = this.create_groups.length > 0;


                settings.auto_sync_time = moment.utc(settings.auto_sync_time, "HH:mm").local().format("HH:mm");
				settings.sync_schedules = !settings.sync_schedules ? [] : settings.sync_schedules; // added due to my database not pulling through the default value for this setting this just ensures its set to an empty array

				this.studentPasswordPreview = this.reformatPassword('student');
				this.employeePasswordPreview = this.reformatPassword('employee');
				
				if (settings.deletion_delay_student) {
					let total = settings.deletion_delay_student;

					if (total < 365) {
						this.deletion_days.student = total;
						this.deletion_years.student = 0;
					} else {
						this.deletion_years.student = Math.floor(total / 365);
						this.deletion_days.student = total - this.deletion_years.student * 365;
					}
				}

				if (settings.deletion_delay_employee) {
					let total = settings.deletion_delay_employee;

					if (total < 365) {
						this.deletion_days.employee = total;
						this.deletion_years.employee = 0;
					} else {
						this.deletion_years.employee = Math.floor(total / 365);
						this.deletion_days.employee = total - this.deletion_years.employee * 365;
					}
				}

				settings.course_name_format = settings.course_name_format === "class_name" && !!settings.include_class_code ? "class_name + ' (' + class_code + ')'" : settings.course_name_format;
				settings.use_same_password = !_.isEmpty(settings.user_password);
				settings.use_same_staff_password = !_.isEmpty(settings.employee_password);
				this.loadingForm = false;

				if (this.type === "organisation") {
					delete settings.org_sync_enabled;
				}

				this.onChangeGroupTypes();
				
				if (_.isEmpty(settings.age_group_student) || _.isEmpty(settings.age_group_student.minor)) {
					settings.age_group_student = {
						type: "age",
						minor: {
							minimum: 0,
							maximum: 13,
						},
						not_adult: {
							minimum: 14,
							maximum: 17,
						},
						adult: {
							minimum: 18,
						}
					}
				}

				return settings;
			},
		},
		matchedGroups: {
			query: gql`
				query MatchedGroups {
					MatchedGroups {
						id
						wondeId
						status
						providerId
					}
				}
			`,
			fetchPolicy: "network-only",
			update(r) {
				return r.MatchedGroups;
			},
		},
		school: {
			query: gql`
				{
					School {
						name
						phase_of_education
						Organisation {
							id
							name
						}
					}
				}
			`,
			update: (r) => r.School,
		},
	},

	methods: {
		async onChangeGroupTypes() {

			const groups = await this.$apollo.query({
				query: gql`
					query Groups($type: String) {
						Groups(type: $type) {
							id
							name
							type
						}
					}
				`,
				variables: {
					type: "misc",
				},
				fetchPolicy: "network-only",

				update: (r) => r.Groups,
			});
			this.newGroups = groups.data.Groups;

			const isGroupMatched = (group) => {
				if (!this.form) return false;
				
				return this.matchedGroups.find((value) => {
					return value.wondeId === group.id && value.status !== "ignored";
				});
			};

			const isGroupPendingSync = (group) => {
				if (!this.form) return false;

				return this.form.group_create_misc.find((value) => {
					return value.id === group.id;
				});
			};

			this.create_groups = !this.group_type ? [] : this.newGroups
				.filter((group) => {
					if (isGroupPendingSync(group) || isGroupMatched(group)) {
						return true;
					}
					return false;
				})
				.map((group) => {
					return group.name;
				});
			
			this.group_type = this.create_groups.length > 0 || this.group_type;
		},
		validateRequiredFields() {
			const errors = [
				{ key: "student_org_unit_id", message: `Please select student ${this.orgUnitLabel.name}` },
				{ key: "employee_org_unit_id", message: `Please select staff ${this.orgUnitLabel.name}` },
			];
			let returnError = null;

			_.each(errors, (error) => {
				if ((!this.form[error.key] || this.form[error.key].length < 1) && this.type === "school") {
					returnError = error;

					return false;
				}
			});

			return returnError;
		},
		async save() {
			const error = this.validateRequiredFields();
			const settingsFields = {
				msft: {
					school: [
						"domain_employee",
						"domain_student_pre_admission",
						"domain",
						"student_active",
						"employee_active",
						"student_provision_rules",
						"student_provision_rule_match",
						"student_org_unit_id",
						"employee_org_unit_id",
						"student_pre_admission_org_unit_id",
						"group_org_unit_id",
						"group_create_mode",
						"group_membership_mode",
						"group_membership_deletion_mode_employee",
						"group_membership_deletion_mode_student",
						"custom_email_letters",
						"deletion_mode_employee",
						"deletion_mode_student",
						"deletion_delay_student",
						"deletion_delay_employee",
						"suspend_delay_student",
						"suspend_delay_employee",
						"creation_mode",
						"creation_mode_employee",
						"class_auto_archive_date",
						"class_auto_archive",
						"class_rollover_date",
						"employee_password",
						"user_password",
						"student_change_password_at_next_login",
						"employee_change_password_at_next_login",
						"department_student",
						"department_employee",
						"office_location_student",
						"office_location_employee",
						"job_title",
						"employee_type",
						"student_password_generation",
						"employee_password_generation",
						"email_format_employee",
						"email_format_student",
						"email_format_student_pre_admission",
						"email_format_student_split_by_firstN",
						"email_format_employee_split_by_firstN",
						"email_format_student_pre_admission_split_by_firstN",
						"email_format_student_split_by_lastN",
						"email_format_employee_split_by_lastN",
						"email_format_student_pre_admission_split_by_lastN",
						"group_create_misc",
						"include_class_code",
						"matching_emails_only_student",
						"matching_emails_only_employee",
						"admin_email",
						"predictions_auto_enabled",
						"first_name_student",
						"first_name_employee",
						"middle_name_student",
						"middle_name_employee",
						"last_name_student",
						"age_group_student",
						"last_name_employee",
						"course_name_format",
						"multiple_class_mapping_enabled",
						"consent_provided_for_minor",
						"postal_code_student",
						"sync_schedules",
						"parental_controls_enabled",
						"student_pre_admission_active",
					],
					organisation: [
						"domain_employee",
						"domain",
						"student_active",
						"employee_active",
						"student_provision_rules",
						"student_provision_rule_match",
						"student_org_unit_id",
						"employee_org_unit_id",
						"group_create_mode",
						"group_membership_mode",
						"group_membership_deletion_mode_employee",
						"group_membership_deletion_mode_student",
						"custom_email_letters",
						"deletion_mode_employee",
						"deletion_mode_student",
						"deletion_delay_student",
						"deletion_delay_employee",
						"suspend_delay_student",
						"suspend_delay_employee",
						"creation_mode",
						"creation_mode_employee",
						"class_auto_archive_date",
						"class_auto_archive",
						"student_password_generation",
						"employee_password_generation",
						"email_format_employee",
						"email_format_student",
						"group_create_misc",
						"matching_emails_only_student",
						"matching_emails_only_employee",
						"sync_schedules",
						"predictions_auto_enabled",
					]
				},
				gapps: {
					school: [
						"creation_mode",
						"creation_mode_employee",
						"deletion_mode_student",
						"deletion_mode_employee",
						"leavers_OU",
						"group_create_mode",
						"group_membership_mode",
						"class_create_mode",
						"class_membership_mode",
						"class_timetable_mode",
						"group_membership_deletion_mode_student",
						"group_membership_deletion_mode_employee",
						"class_membership_deletion_mode_student",
						"class_membership_deletion_mode_employee",
						"creation_groups",
						"deletion_delay_student",
						"deletion_delay_employee",
						"suspend_delay_student",
						"suspend_delay_employee",
						"email_format_employee",
						"email_format_student_pre_admission",
						"student_password_generation",
						"employee_password_generation",
						"hide_employee_forename",
						"custom_email_letters",
						"email_format_student",
						"email_format_student_split_by_firstN",
						"email_format_employee_split_by_firstN",
						"email_format_student_pre_admission_split_by_firstN",
						"email_format_student_split_by_lastN",
						"email_format_employee_split_by_lastN",
						"email_format_student_pre_admission_split_by_lastN",
						"employee_org_unit_id",
						"student_org_unit_id",
						"student_pre_admission_org_unit_id",
						"domain",
						"domain_employee",
						"domain_student_pre_admission",
						"student_org_unit_structure",
						"class_auto_archive",
						"class_auto_archive_date",
						"class_reprovision_mode",
						"class_reprovision_date",
						"group_create_misc",
						"dashboard_tiles",
						"user_password",
						"employee_password",
						"class_rollover_date",
						"student_change_password_at_next_login",
						"employee_change_password_at_next_login",
						"enforce_mfa",
						"org_sync_enabled",
						"matching_emails_only_employee",
						"matching_emails_only_student",
						"student_org_department",
						"employee_org_department",
						"student_provision_rules",
						"student_active",
						"student_provision_rule_match",
						"employee_active",
						"first_name_student",
						"first_name_employee",
						"middle_name_student",
						"middle_name_employee",
						"last_name_student",
						"last_name_employee",
						"class_section",
						"sync_schedules",
						"course_name_format",
						"student_pre_admission_active",
						"predictions_auto_enabled",
						"admin_email",
						"future_employee_enabled",
						"future_employee_creation_lead_time",
					],
					organisation: [
						"creation_mode",
						"creation_mode_employee",
						"deletion_mode_student",
						"deletion_mode_employee",
						"leavers_OU",
						"group_create_mode",
						"group_membership_mode",
						"class_create_mode",
						"class_membership_mode",
						"class_timetable_mode",
						"group_membership_deletion_mode_student",
						"group_membership_deletion_mode_employee",
						"class_membership_deletion_mode_student",
						"class_membership_deletion_mode_employee",
						"creation_groups",
						"deletion_delay_student",
						"deletion_delay_employee",
						"suspend_delay_student",
						"suspend_delay_employee",
						"email_format_employee",
						"student_password_generation",
						"employee_password_generation",
						"hide_employee_forename",
						"custom_email_letters",
						"email_format_student",
						"email_format_student_split_by_firstN",
						"email_format_employee_split_by_firstN",
						"email_format_student_split_by_lastN",
						"email_format_employee_split_by_lastN",
						"employee_org_unit_id",
						"student_org_unit_id",
						"domain",
						"domain_employee",
						"student_org_unit_structure",
						"class_auto_archive",
						"class_auto_archive_date",
						"class_reprovision_mode",
						"class_reprovision_date",
						"group_create_misc",
						"dashboard_tiles",
						"user_password",
						"employee_password",
						"class_rollover_date",
						"student_change_password_at_next_login",
						"employee_change_password_at_next_login",
						"enforce_mfa",
						"org_sync_enabled",
						"matching_emails_only_employee",
						"matching_emails_only_student",
						"student_provision_rules",
						"student_active",
						"student_provision_rule_match",
						"employee_active",
						"sync_schedules",
						"course_name_format",
						"predictions_auto_enabled",
						"admin_email",
						"student_org_department",
						"employee_org_department",
						"future_employee_enabled",
						"future_employee_creation_lead_time",
					]
				}
			}
			const createMisc = this.group_type ? this.create_groups.map((selected) => {
				const { id, name, type } = this.newGroups.find((group) => {
					return group.name === selected;
				})
				return { id, name, type };
			}): [];

			if (error) {
				this.$message.error(error.message);
				return;
			}

			this.loading = true;

			this.form.deletion_delay_student = this.deletion_days.student + this.deletion_years.student * 365;
			this.form.deletion_delay_employee = this.deletion_days.employee + this.deletion_years.employee * 365;

			let insert = _.pickBy(this.form, (value, key) => {
				return key !== "__typename" && key !== "id" && key !== "email_formats";
			});
			insert.student_provision_rules = _.map(this.student_rule_object.rules, (rule) => _.pickBy(rule, (value, key) => key !== "__typename"));
			insert.sync_schedules = _.map(this.form.sync_schedules, (schedule) => _.pickBy(schedule, (value, key) => key !== "__typename"));
			insert.student_active = this.student_rule_object.active;
			insert.student_provision_rule_match = this.student_rule_object.match;
			insert.employee_active = this.employee_rule_object.active;
			insert.student_org_unit_structure = _.compact(insert.student_org_unit_structure);
			insert.class_auto_archive_date = insert.class_auto_archive === "auto" ? (moment(insert.class_auto_archive_date).isValid() ? moment(insert.class_auto_archive_date).format("YYYY-MM-DD"): "") : "";
			insert.class_rollover_date = insert.class_auto_archive === "auto" ? (moment(insert.class_rollover_date).isValid() ? moment(insert.class_rollover_date).format("YYYY-MM-DD"): "") : "";
			insert.class_reprovision_date = this.form.class_reprovision_mode !== "archive_only" ? moment(insert.class_reprovision_date).format("YYYY-MM-DD") : "";
			insert.hide_employee_forename = !!insert.hide_employee_forename;
			insert.group_create_misc = createMisc;
			insert.student_change_password_at_next_login = !!insert.student_change_password_at_next_login;
			insert.employee_change_password_at_next_login = !!insert.employee_change_password_at_next_login;

			//password generation
			insert.student_password_generation = this.student_password_generation;
			insert.employee_password_generation = this.employee_password_generation;
			insert.email_format_student = this.appendNumberInFormat(this.form.email_format_student.format);
			insert.email_format_employee = this.appendNumberInFormat(this.form.email_format_employee.format);
			insert.email_format_student_pre_admission = this.appendNumberInFormat(this.form.email_format_student_pre_admission.format);

			insert.email_format_student_split_by_firstN = this.form.email_format_student.countFirstN;
			insert.email_format_employee_split_by_firstN = this.form.email_format_employee.countFirstN;
			insert.email_format_student_pre_admission_split_by_firstN = this.form.email_format_student_pre_admission.countFirstN;
			insert.email_format_student_split_by_lastN = this.form.email_format_student.countLastN;
			insert.email_format_employee_split_by_lastN = this.form.email_format_employee.countLastN;
			insert.email_format_student_pre_admission_split_by_lastN = this.form.email_format_student_pre_admission.countLastN;
			insert.age_group_student = this.removePropertyDeep(insert.age_group_student, "__typename");
			insert = _.pick(insert, settingsFields[this.providerCode][this.type]);

			for (let userType of ["student", "employee"]) {
				if (this.form[`email_format_${userType}`].usingBrokenJS) delete insert[`email_format_${userType}`];

				if (!this.form.org_sync_enabled && !emailValidator.validate(this.form[`email_format_${userType}`].sample)) {
					const displayType = userType === "employee" ? "staff" : userType;
					this.loading = false;
					this.$emit("Saving", this.loading);
					console.log(this.form[`email_format_${userType}`])
					this.$message.error(`Invalid email address format for ${displayType}`);
					return;
				}

				const dictionaryOptionTypeCount = (type) => {
					const options = _(this.passwordDictionaries)
						.filter((option) => option.type === type)
						.map("value")
						.value();

					return _.filter(this[`${userType}_password_generation`], (option) => options.includes(option)).length;
				};

				if (this[`${userType}_password_generation`].length >= 1 && dictionaryOptionTypeCount("mis_fields") < 1 && dictionaryOptionTypeCount("common") < 3) {
					this.loading = false;
					this.$message.error("Settings not saved - please make sure you're using at least three dictionaries to generate the passwords")
					return;
				}
			}

			if (this.providerCode === "gapps") {
				insert.enforce_mfa = !!insert.enforce_mfa;
				// check password length
				if (this.form.creation_mode == "auto" && this.form.user_password && this.form.user_password.length < 8) {
					this.loading = false;
					this.$message.error("Invalid password");
					return;
				}

				if (this.form.creation_mode_employee == "auto" && this.form.employee_password && this.form.employee_password.length < 8) {
					this.loading = false;
					this.$message.error("Invalid password");
					return;
				}

				if (this.form.class_auto_archive == "auto" && !this.form.class_rollover_date) {
					this.loading = false;
					this.$message.error("Please select rollover date");
					return;
				}

			}

			let updateAllEmails = false;
			
			if (!this.form.org_sync_enabled && (this.emailFormatChange.student || this.emailFormatChange.employee)) {
				try {
					await this.$alert(
						`A new alias email address  will be created for your existing matched users if you have changed your domain name settings OR you have changed your email address naming convention(s). 
						The primary email address of any matched users will not be changed but this can be actioned via the Google Admin Console.
						<br><br>New users will be created with current naming convention and suffix according to your domain selection.`,
						{
							confirmButtonText: "OK",
							dangerouslyUseHTMLString: true,
							showClose: false,
						}
					);
					updateAllEmails = true;
				} catch (e) {
					updateAllEmails = false;
				}
			
			}

			if (_.filter(insert.sync_schedules, (schedule) => schedule.enabled).length === 0) {
				delete insert.sync_schedules;
			}
			
			this.$apollo
				.mutate({
					mutation: gql`
						mutation SaveSettings($object: SettingsInput!, $type: SettingsTypeEnum) {
							SaveSettings(object: $object, type: $type) {
								creation_mode
								creation_mode_employee
								deletion_mode_student
								deletion_mode_employee
								leavers_OU
								class_create_mode
								class_membership_mode
								class_timetable_mode
								group_membership_deletion_mode_student
								group_membership_deletion_mode_employee
								class_membership_deletion_mode_student
								class_membership_deletion_mode_employee
								creation_groups
								deletion_delay_student
								deletion_delay_employee
								suspend_delay_student
								suspend_delay_employee
								student_active
								email_format_employee
								email_format_student
								employee_password_generation
								student_password_generation
								student_provision_rule_match
								employee_org_unit_id
								custom_email_letters
								student_org_unit_id
								domain
								domain_employee
								employee_active
								student_provision_rules {
									group
									operator
									value
								}
								student_org_unit_structure
								class_auto_archive
								class_auto_archive_date
								class_reprovision_mode
								class_reprovision_date
								group_create_misc {
									id
									name
									type
								}
								dashboard_tiles
								sftp_host
								sftp_port
								sftp_username
								sftp_password
								user_password
								employee_password
								password_policy_student
								student_change_password_at_next_login
								employee_change_password_at_next_login
								enforce_mfa
							}
						}
					`,
					variables: {
						object: insert,
						type: this.type ? this.type : "school"
					},
				})
				.then((r) => {
					this.loading = false;
					this.$emit("Saved");
					this.$message.success("Settings saved");
					
					if (updateAllEmails) {
						this.processUserUpdate(insert);
					} else {
						this.originalSettingsValues = _.clone(insert);
					}
				})
				.catch((e) => {
					this.loading = false;
					this.$message.error("Failed to update settings");
				});
		},
		allowDrop(ev) {
			ev.preventDefault();
		},
		drag(ev) {
			ev.dataTransfer.setData("text", ev.target.id);
		},
		drop(ev, type) {
			let data = ev.dataTransfer.getData("text");
			let getValue = this.emailItems.find(item => item.label === data)
			if (type === 'employee' && getValue.type === 'student') { 
				return ;
			}
			if (this[type + '_format'].length > 0) {
				let last = this[type + '_format'][this[type + '_format'].length - 1];				
				let isCustomFormat = this.setType(last,type);
				if (this.setType(getValue.value, type) !== isCustomFormat) {
					return ;
				}
			}
	
			if (!this[type + '_format'].includes(getValue.value)){
				this[type + '_format'].push(getValue.value);
				this.processData(type)
			}
		},
		dropDictionary(ev, type) {
			let data = ev.dataTransfer.getData("text");
			let getValue = this.passwordDictionaries.find(item => item.label === data)
			this.passwordDictionaryOptions[type].push(getValue);
			
			if (!this[type + '_password_generation'].includes(getValue.value)){
				this[type + '_password_generation'].push(getValue.value);
				const pswd = this[type + '_password_generation'].map((dictionary) => {
					const randomIndex = Math.floor(Math.random() * (this.mis_fields[dictionary] && dictionary.startsWith('mis_') ? this.mis_fields[dictionary].length : this.dictionaries[dictionary].length));
    				return dictionary.startsWith('mis_') ? this.mis_fields[dictionary][randomIndex] : this.dictionaries[dictionary][randomIndex];
				})

				if(this.providerCode === 'msft') {
					const msftEnforcePolicyPswd = pswd.join('');
					const randomIndex = Math.floor(Math.random() * this.dictionaries['numbers'].length);
					this[type+`PasswordPreview`] = msftEnforcePolicyPswd.charAt(0).toUpperCase() + msftEnforcePolicyPswd.slice(1) + this.dictionaries['numbers'][randomIndex];
				} else {
					this[type+`PasswordPreview`] = pswd.join('');
				}
			}
		},
		reformatPassword(type){
			if(!_.isEmpty(this[`${type}_password_generation`]) && this[`${type}_password_generation`].length > 0) {
				const pswd = this[`${type}_password_generation`].map((dictionary) => {
					const randomIndex = Math.floor(Math.random() * (this.mis_fields[dictionary] && dictionary.startsWith('mis_') ? this.mis_fields[dictionary].length : this.dictionaries[dictionary].length));
    				return dictionary.startsWith('mis_') ? this.mis_fields[dictionary][randomIndex] : this.dictionaries[dictionary][randomIndex];
				})
				
				if(this.providerCode === 'msft') {
					const msftEnforcePolicyPswd = pswd.join('');
					const randomIndex = Math.floor(Math.random() * this.dictionaries['numbers'].length);
					return msftEnforcePolicyPswd.charAt(0).toUpperCase() + msftEnforcePolicyPswd.slice(1) + this.dictionaries['numbers'][randomIndex];
				} else {
					return pswd.join('');
				}
			}

			return '';

		},
		disableAutoArchiveDate(time) {
			return moment(time).format("YYYY-MM-DD") <= moment(this.form.class_auto_archive_date).format("YYYY-MM-DD");
		},

		disableRolloverDate(time) {
			return moment(time).format("YYYY-MM-DD") <= moment(this.form.class_auto_archive_date).format("YYYY-MM-DD");
		},
		isLetter(e) {
			let char = String.fromCharCode(e.keyCode);
			if(/^[a-zA-Z0-9]+$/.test(char)) return true;
			else e.preventDefault();
		},
		
		async updateAllUsers(rows) {
			const perPage = 5;
			let curPage = 1;
			let promises = [];
			let chunk = _.chunk(rows, perPage)[curPage - 1];

			do {
				promises.push(this.updateUsersChunk(chunk));
				curPage++;
				chunk = _.chunk(rows, perPage)[curPage - 1];
			} while (chunk);
			
			await Promise.all(promises);
		},

		async updateUsersChunk(input) {
			await this.$apollo.mutate({
				mutation: gql`
					mutation UpdateUsers($input: [UserUpdateInput!]!) {
						UpdateUsers(input: $input)
					}
				`,
				variables: {
					input
				}
			});
		},

		async getMatchedUsers() {
			const users = await this.$apollo.query({
				query: gql`
					query Directory {
						Directory {
							id
							WondeUsers {
								matched_id
								id
								status
								email
								base_type
							}
						}
					}
				`,
				fetchPolicy: "network-only"
			});
			
			return _.filter(users.data.Directory.WondeUsers, (user) => {
				return (user.status === "created" || user.status === "matched") && this.emailFormatChange[user.base_type];
			});
		},

		async processUserUpdate(insert) {
			this.loading = true;
			
			try {
				
				const matchedUsers = await this.getMatchedUsers();
				await this.updateAllUsers(_.map(matchedUsers, (user) => {
					return {
						spId: user.matched_id,
						updateEmail: true,
						idpId: user.id,
					}
				}));
				this.loading = false;
				this.$message.success("Primary emails have been updated. Please re-fetch users on the Directory page");
			} catch (e) { 
				this.loading = false;
				this.$message.error("Something went wrong while updating users");
			}
			this.originalSettingsValues = _.clone(insert);
		},

		appendNumberInFormat(format) {
			if (_.isEmpty(format)) return "number";

			if (!format.split(' + ').includes('number')) {
				let split = format.split(' + ');
				split.push('number')
				return split.join(' + ').toString()
			}

			return format;
		},

		capitalize(word) {
			return _.startCase(_.toLower(word));
		},

		changeAgeGroup() {
			this.form.age_group_student.not_adult.minimum = this.form.age_group_student.minor.maximum + 1;
			this.form.age_group_student.adult.minimum = this.form.age_group_student.not_adult.maximum + 1;
		},

		removePropertyDeep(obj, propToRemove) {
			if (Array.isArray(obj)) {
				return obj.map(item => this.removePropertyDeep(item, propToRemove));
			}

			if (obj !== null && typeof obj === 'object') {
				const newObj = {};
				for (const [key, value] of Object.entries(obj)) {
					if (key !== propToRemove) {
						newObj[key] = this.removePropertyDeep(value, propToRemove);
					}
				}
				return newObj;
			}

			return obj;
		}

	}, 

	data() {
		return {
			deletion_days: {
				student: 0,
				employee: 0,
			},
			deletion_years: {
				student: 0,
				employee: 0,
			},
			student_rule_object: {
				active: null,
				match: null,
				rules: null,
			},
			employee_rule_object: {
				active: null,
			},
			form: null,
			staff_forename_options: [
				{
					label: "Yes, I would like to create staff user accounts with titles instead of forenames",
					value: 1,
				},
				{
					label: "No, I would not like to create staff user accounts with titles instead of forenames",
					value: 0,
				},
			],
			newGroups: [],
			create_groups: [],
			group_type: true,
			loading: false,
			loadingForm: false,
			student_password_generation: [],
			employee_password_generation: [],
			studentPasswordPreview: "",
			employeePasswordPreview: "",
			dictionaries: {
				adjectives: ['happy', 'funny', 'bright', 'colorful'],
				animals: ['elephant', 'dog', 'mouse', 'cat'],
				shapes: ['triangle', 'square', 'rectangle', 'circle'],
				numbers: ['123', '345', '232', '535'],
				natural_objects: ['palm', 'willow', 'birch', 'cedar'],
				special_chars: ['@', '!', '?', '>']
			},
			mis_fields: {
				mis_year_date_of_birth: ['2012', '2011', '2010', '2009'],
				mis_month_date_of_birth: ['01', '02', '03', '04'],
				mis_day_date_of_birth: ['31', '30', '29', '28'],
				mis_forename: ['ben', 'rex', 'sam', 'barry'],
				mis_surname: ['smith', 'doe', 'williams', 'moore'],
				mis_id: ['1', '2', '3', '4'],
				mis_government_id: ['1', '2', '3', '4']
			},
			student_format: [],
			studentEmailPreview:"",
			employeeEmailPreview: "",
			employee_format: [],
			custom_email_letters: "",
			value: "",
			pickerOption: {
				disabledDate(time) {
					return moment(time).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD");
				},
			},
			pickerOptionReprovision: {
				disabledDate: this.disableAutoArchiveDate,
			},
			pickerOptionRollover: {
				disabledDate: this.disableRolloverDate,
			},
			isCustomFormat: null,
			passwordDictionaries: [
				{
					label: 'Adjectives',
					value: 'adjectives',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'common',
				},
				{
					label: 'Animals',
					value: 'animals',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'common',
				},
				{
					label: 'Shapes',
					value: 'shapes',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'common',
				},
				{
					label: 'Natural objects',
					value: 'natural_objects',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'common',
				},
				{
					label: 'Numbers (0-1000)',
					value: 'numbers',
					providers: ['gapps'],
					disabled: true,
					type: 'common',
				},
				{
					label: 'Common keyboard symbols (!, @, $, …)',
					value: 'special_chars',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'common',
				},
				{
					label: 'Year of birth',
					value: 'mis_year_date_of_birth',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'mis_fields'
				},
				{
					label: 'Month of birth',
					value: 'mis_month_date_of_birth',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'mis_fields'
				},
				{
					label: 'Day of birth',
					value: 'mis_day_date_of_birth',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'mis_fields'
				},
				{
					label: 'First name',
					value: 'mis_forename',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'mis_fields'
				},
				{
					label: 'Last name',
					value: 'mis_surname',
					providers: ['gapps', 'msft'],
					disabled: true,
					type: 'mis_fields'
				},
				{
					label: 'MIS ID',
					value: 'mis_id',
					providers: ['msft'],
					disabled: true,
					type: 'mis_fields'
				},
				{
					label: 'Government ID',
					value: 'mis_government_id',
					providers: ['msft'],
					disabled: true,
					type: 'mis_fields'
				}
			],
			emailItems: [
				{
					label: 'mis id',
					value: 'mis_id',
					disabled: true,
					type: 'common',
				},
				{
					label: 'mis secondary id',
					value: 'mis_secondary_id',
					disabled: true,
					type: 'common',
				},
				{
					label: 'first name letter',
					value: 'first_name_letters[0]',
					disabled: true,
					type: 'common',
				},
				{
					label: 'first name x letters',
					value: 'first_name_letters[x]',
					disabled: true,
					type: 'common',
				},
				{
					label: 'first name',
					value: 'first_name',
					disabled: true,
					type: 'common',
				},
				{
					label: 'last name letter',
					value: 'last_name_letters[0]',
					disabled: true,
					type: 'common',
				},
				{
					label: 'last name',
					value: 'last_name',
					disabled: true,
					type: 'common',
				},
				{
					label: 'cohort year',
					value: 'cohort_year.toString().slice(-2)',
					disabled: true,
					type: 'common',
				},
				{
					label: 'admission number',
					value: 'education_details.admission_number',
					type: 'student',
					disabled: true
				},
				{
					label: 'admission date',
					value: 'education_details.year_of_admission.toString()',
					type: 'student',
					disabled: true
				},
				{
					label: 'year of admission',
					value: 'education_details.year_of_admission.toString().slice(-2)',
					type: 'student',
					disabled: true
				},				
				{
					label: 'learner number',
					value: 'education_details.learner_number',
					type: 'student',
					disabled: true
				},
				{
					label: 'number',
					value: 'number',
					type: 'common',
					disabled: true
				},
				{
					label: 'letters',
					value: 'letters',
					type: 'common',
					disabled: true
				},
			],
			emailFormatOption: [],
			passwordDictionaryOptions: {
				student: [],
				employee: []
			},
			isPasswordVisible: false,
			isStaffPasswordVisible: false,
			passwordPolicies: [
				{
					label: "Four-digit passcode",
					value: 4,
				},
				{
					label: "Six-digit passcode",
					value: 6,
				},
				{
					label: "Eight or more numbers and letters password",
					value: 8,
				},
			],
			changePasswordOptions: [
				{
					label: "Yes, I would like to require users to change their passwords at next login",
					value: 1,
				},
				{
					label: "No, I would not like to require users to change their passwords at next login",
					value: 0,
				},
			],
			originalSettingsValues: null,
			dotsInEmailCount: 0,
			excludedFields: {
				gapps: [],
				msft: [],
				apl: ["admission-number", "admission-date", "admission-year"],
			},
			school: {
				name: null
			},
			previewUser: {
				first_name: null,
				last_name: null,
			},
			consentProvidedForMinorOptions: [
				{
					label: "None",
					value: null,
				},
				{
					label: "Granted",
					value: "Granted",
				},
				{
					label: "Denied",
					value: "Denied",
				},
			],
			fieldNames: {
				groups: {
					"registration-code": {
						label: "Registration Code",
						value: "registration_code"
					},
					"registration-name": {
						label: "Registration Name",
						value: "registration_name"
					},
					"year-code": {
						label: "Year Code",
						value: "year_code"
					},
					"year-name": {
						label: "Year Name",
						value: "year_name"
					},
					"house-code": {
						label: "House Code",
						value: "house_code"
					},
					"house-name": {
						label: "House Name",
						value: "house_name"
					},
					"boarding-code": {
						label: "Boarding Code",
						value: "boarding_code"
					},
					"boarding-name": {
						label: "Boarding Name",
						value: "boarding_name"
					},
					"course-code": {
						label: "Course Code",
						value: "course_code"
					},
					"course-name": {
						label: "Course Name",
						value: "course_name"
					},
					"misc-code": {
						label: "Misc Code",
						value: "misc_code"
					},
					"misc-name": {
						label: "Misc Name",
						value: "misc_name"
					},
					"user-code": {
						label: "User Code",
						value: "user_code"
					},
					"user-name": {
						label: "User Name",
						value: "user_name"
					},
					"campus-code": {
						label: "Campus code",
						value: "campus_code"
					},
					"campus-name": {
						label: "Campus Name",
						value: "campus_name"
					},
					"division-code": {
						label: "Division Code",
						value: "division_code"
					},
					"division-name": {
						label: "Division Name",
						value: "division_name"
					},
					"department-code": {
						label: "Department Code",
						value: "department_code"
					},
					"department-name": {
						label: "Department Name",
						value: "department_name"
					},
				},
				title: {
					"employee-title": {
						label: "Employee Title",
						value: "employee_title"
					},
					"contract-role": {
						label: "Contract Role",
						value: "contract_role"
					},
				},
				school: {
					"school-name": {
						label: "School Name",
						value: "school_name"
					},
					"establishment-number": {
						label: "Establishment Number",
						value: "establishment_number"
					},
					"urn": {
						label: "URN",
						value: "urn"
					},
					"la-code": {
						label: "LA Code",
						value: "la_code"
					},
				},
				user: {
					name: {
						"firstname": {
							label: "First name",
							value: "firstname"
						},
						"firstname-legal": {
							label: "Legal first name",
							value: "firstname_legal"
						},
						"initials": {
							label: "Initials",
							value: "initials"
						},
						"middlename": {
							label: "Middle name",
							value: "middlename"
						},
						"lastname": {
							label: "Last name",
							value: "lastname"
						},
						"lastname-legal": {
							label: "Legal last name",
							value: "lastname_legal"
						},
						"title": {
							label: "Title",
							value: "title"
						}
					},
					classTeacher: {
						"firstname": {
							label: "Teacher first name",
							value: "firstname"
						},
						"lastname": {
							label: "Teacher last name",
							value: "lastname"
						},
						"title": {
							label: "Teacher title",
							value: "title"
						},
					},
					educationDetails: {
						"admission-number": {
							label: "Admission number",
							value: "admission_number"
						},
						"learner-number": {
							label: "Learner number",
							value: "learner_number"
						},
						"current-nc-year": {
							label: "Current nc year",
							value: "current_nc_year"
						}
					},
					employmentDetails: {
						"teacher-number": {
							label: "Teacher number",
							value: "teacher_number"
						},
						"staff-code": {
							label: "Staff code",
							value: "staff_code"
						},
						"teacher-category": {
							label: "Teacher category",
							value: "teacher_category"
						},
						"role-name": {
							label: "Role name",
							value: "role_name"
						}
					},
					identifiers: {
						student: {
							"ad-username": {
								label: "Active Directory username",
								value: "ad_username"
							},
							"barcode": {
								label: "Barcode",
								value: "barcode"
							},
							"mis-username": {
								label: "MIS/SIS username",
								value: "mis_username"
							},
							"mis-id": {
								label: "MIS/SIS ID",
								value: "mis_id"
							},
							"mis-tertiary-id": {
								label: "MIS/SIS Tertiary ID",
								value: "mis_tertiary_id"
							}
						},
						employee: {
							"ad-username": {
								label: "Active Directory username",
								value: "ad_username"
							},
							"barcode": {
								label: "Barcode",
								value: "barcode"
							},
							"mis-username": {
								label: "MIS/SIS username",
								value: "mis_username"
							},
							"mis-id": {
								label: "MIS/SIS ID",
								value: "mis_id"
							}
						}
					},
					regionalData: {
						"au-gov-id": {
							label: "Government ID (Australia)",
							value: "au_gov_id"
						},
						"au-usi": {
							label: "USI (Australia)",
							value: "au_usi"
						},
						"nz-iwi": {
							label: "Iwi (New Zealand)",
							value: "nz_iwi"
						}
					}
				},

				class: {
					"class-id": {
						label: "Class ID",
						value: "class_id"
					},
					"class-name": {
						label: "Class name",
						value: "class_name"
					},
					"class-code": {
						label: "Class code",
						value: "class_code"
					},
					"class-mis-id": {
						label: "Class MIS ID",
						value: "class_mis_id"
					},
					"class-description": {
						label: "Class description",
						value: "class_description"
					},
					"class-subject-id": {
						label: "Class subject ID",
						value: "class_subject_mis_id"
					},
					"class-subject-code": {
						label: "Class subject code",
						value: "class_subject_code"
					},
					"class-subject-name": {
						label: "Class subject name",
						value: "class_subject_name"
					},
					"site-number": {
						label: "Site number",
						value: "custom_value"
					},
					"current-year": {
						label: "Current year",
						value: "current_year"
					},
				},
			},
		};
	},

	watch: {
		loading() {
			this.$emit("Saving", this.loading);
		},
		"form.use_same_password"(newVal) {
			if (!newVal) {
				this.form.user_password = "";
			}
		},
		"form.use_same_staff_password"(newVal) {
			if (!newVal) {
				this.form.employee_password = "";
			}
		}
	},
};
</script>
